<div class="canvas-mini-tile-wrapper">
  @for (tileData of tilesData; track tileData.tileId; let i = $index) {
    <div class="canvas-mini-tile"
         [attr.data-color]="tileData.displayColor"
         [class.first]="i === 0"
         [class.last]="i === tilesData.length - 1"
         [class.outdated]="tileData.isStale"
         (click)="onTileClick($event, tileData.tileId, i)">
      @if (tileData.alarmBadge && !replayTimestamp) {
        <div class="alarm-badge" [class.unacked]="tileData.alarmBadge === 'unacked'" [class.acked]="tileData.alarmBadge === 'acked'"></div>
      }
      @if (tileData.loading) {
        <motn-spinner></motn-spinner>
      } @else {
        <div class="tile-info">
          @if (tileData.displayIcon && !hideIcon) {
            <motn-fa-icon
              [icon]="tileData.displayIcon"
              class="tile-icon icon"
            ></motn-fa-icon>
          }
          <div class="tile-body">
            <div class="tile-value">
              {{ tileData.displayValue || '-' }}@if (tileData.displayValue && tileData.displayUnits) {<span class="tile-units"> {{ tileData.displayUnits }}</span>}
            </div>
            @if (tileData.displayAge) {<div class="tile-age">{{ tileData.displayAge }}</div>}
          </div>
        </div>
      }
    </div>
  }
</div>
